import React from "react";
import {useTable, useSortBy} from "react-table";
import {useSelector} from "react-redux";
import ReactPaginate from "react-paginate";
import {DefaultArrow, DownArrow, UpArrow} from "../../../Resident/sortArrows";
import AddInspectionModal from "../modals/AddInspectionModal";
import InspectionForm from "../modals/InspectionForm";
import DatePicker from "react-datepicker";

const InspectionsTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });

  const [inspections, setInspections] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [viewInspection, setViewInspection] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [filters, setFilters] = React.useState({
    facility: '',
    date: ''
  });


  const fetchInspections = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/inspection_index.json?${$.param(createRansackQuery())}`,
      success: (response) => {
        setInspections(response.inspections);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    })
  }

  const createRansackQuery = () => {
    const formattedDate = moment.isMoment(filters.date) ? filters.date.format('DD/MM/YYYY') : filters.date;
    return {
      page: currentPage,
      'q[affiliate_facility_name_i_cont]': filters.facility || undefined,
      'q[inspection_date_eq]': formattedDate || undefined
    };
  };

  React.useEffect(() => {
    fetchInspections();
  }, [currentPage]);

  const columns = React.useMemo(() => [
    {
      Header: "Completed On",
      id: "inspection_date",
      disableSortBy: true,
      accessor: (row) => row.inspection_date,
      Cell: ({cell: {row: {original}}}) => (
        <span>{moment.utc(original.inspection_date).format('MM/DD/YYYY')}</span>
      )
    },
    {
      Header: "Facility",
      id: "facility_name",
      disableSortBy: true,
      accessor: (row) => row.facility_name,
      Cell: ({cell: {row: {original}}}) => {
        const { organizationName } = state;
        return (
          <a
            href={`/organizations/${organizationName}/facilities/${original.facility_id}`}
            className="text-primary text-decoration-underline"
          >
            {original.facility_name}
          </a>
        );
      }
    },
    {
      Header: "Status",
      id: "status",
      disableSortBy: true,
      accessor: (row) => row.status,
      Cell: ({cell: {row: {original}}}) => (
       <span>{original.status}</span>
      )
    },
    {
      Header: "Completed By",
      id: "inspector_name",
      accessor: (row) => row.inspector_name,
      disableSortBy: true,
      Cell: ({cell: {row: {original}}}) => (
        <span>{original.inspector_name}</span>
      )
    },
    {
      Header: "Actions",
      id: "view",
      disableSortBy: true,
      Cell: ({ cell: { row: { original } } }) => (
        <button
          className="btn btn-primary"
          onClick={async () => {
            setLoading(true);
            try {
              const res = await fetch(`/organizations/${original.organization_name}/facilities/${original.facility_id}/inspections/${original.id}.json`);
              const data = await res.json();
              setViewInspection(data);
            } catch (error) {
              console.error("Failed to fetch inspection:", error);
              alert("Unable to load inspection details.");
            } finally {
              setLoading(false);
            }
          }}
        >
          View
        </button>
      )
    } 
  ], [inspections])

  const {getTableProps, headerGroups, rows, prepareRow} = useTable(
    {
      columns,
      data: inspections,
      initialState: {},
      manualSorting: true
    },
    useSortBy
  );

  return (
    <>      
      <div className="row align-items-end mb-3">
        <div className="col-md-3">
          <label htmlFor="facilityFilter" className="form-label">Facility</label>
          <input
            type="text"
            id="facilityFilter"
            className="form-control"
            value={filters.facility}
            onChange={(e) => setFilters({ ...filters, facility: e.target.value })}
          />
        </div>

        <div className="col-md-3">
          <label>Date</label>
          <div></div>
          <DatePicker
            className="form-control"
            selected={filters.date}
            onChange={(new_date) => setFilters({ ...filters, date: new_date })}
            placeholderText="MM/DD/YYYY" />
        </div>

        <div className="col-md-6 d-flex justify-content-end">
          <button
            className="btn btn-primary"
            onClick={() => {
              setCurrentPage(1);
              fetchInspections();
            }}
          >
            Apply
          </button>
        </div>
      </div>


      
      <table {...getTableProps()} className="table table-responsive">
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
            <th />
          </tr>
        ))}
        </thead>
        <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
        )}
        </tbody>
      </table>
      {
        totalPages > 1 && <ReactPaginate
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          pageCount={totalPages}
          onPageChange={(page) =>
            setCurrentPage(page.selected + 1)
          }
        />
      }
      {viewInspection && (
        <AddInspectionModal isOpen={!!viewInspection} readOnly={true} onClose={() => setViewInspection(null)}>
          <InspectionForm
            inspection={viewInspection}
            readOnly={true}
            onClose={() => setViewInspection(null)}
          />
        </AddInspectionModal>
      )}
    </>
  )
}

export default InspectionsTab;
